import React from "react";

const SocialMedia = ({ sm }) => {
  return (
    <a
      href={sm.url}
      target="_blank"
      rel="noreferrer"
      className="flex items-center gap-4 rounded-[1.5rem] border border-white/15 bg-black/10 p-4 shadow-glass transition hover:-translate-y-1 hover:bg-white/10"
    >
      <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-white/90 p-3">
        <img className="h-full w-full object-contain" src={sm.image} alt={sm.title} />
      </div>
      <div>
        <div className="text-sm uppercase tracking-[0.24em] text-skin-accentSoft">
          Reach Out
        </div>
        <div className="mt-1 font-display text-xl font-semibold text-skin-text">
          {sm.title}
        </div>
      </div>
    </a>
  );
};

export default SocialMedia;
